import styled from 'styled-components'

import { GRID_UNIT, Text } from 'mf-ui-components'

export const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  gap: ${GRID_UNIT * 2}px;
  height: 100%;
  margin: 0 1px;
  width: 100%;
`

export const ValueComponent = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  height: 100px;
  border: 1px solid ${({ theme }) => theme.tokens.interface.neutral.light};
  border-radius: 4px;
`

export const ContributionAndOutcome = styled(ValueComponent)`
  background-color: ${({ theme }) => theme.tokens.space.tertiary.regular};
`

export const ContributionItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const Profit = styled(ValueComponent)`
  background-color: ${({ theme }) =>
    theme.tokens.interface.feedback.positive.lightest};
`

export const ProfitText = styled(Text)`
  max-width: 122px;
  text-align: center;
`
